import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useIntl } from "@leagueplatform/locales";
import { Masonry } from "@leagueplatform/masonry";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { MASONRY } from "common/constants";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const HQSDetailsPage = () => {
  usePageViewAnalytics({ screen_name: "Health Quotient Score Details" });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "STR_HEALTH_QUOTIENT_SCORE" }));

  return (
    <PageContentWrapper>
      <PageHeader
        headingText={formatMessage({ id: "STR_HEALTH_QUOTIENT_SCORE" })}
      />
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_HQS_DETAILS} />
    </PageContentWrapper>
  );
};
